/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
"use client";

import React from "react";
import styles from "./serviceCardItem.module.css";
import { Button } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";

const ServiceCardItem = ({ category }) => {
  const router = useRouter();
  const handleButValider = () => {
    router.push(
      `/service/paiement/choixPaiement/${category.identifiantCategorieAbonnement}`
    );
  };

  //console.log(category);
  return (
    <div className={styles.container}>
      <div className={styles.cardTitre}>{category.description}</div>
      <div className={styles.cardLogo}>
        {category.nomLogoImg && (
          <Image
            alt="carte"
            src={"/carte_standard.png"}
            width={230}
            height={100}
          />
        )}
      </div>
      <div className={styles.cardPrix}>{category.tarif} FCFA</div>
      <div className={styles.cardDescription}>
        {category.services &&
          category.services.map((service, i) => {
            return <div key={i}> - {service.description} </div>;
          })}
      </div>
      <div className={styles.cardButton}>
        <Button
          style={{
            width: "180px",
            backgroundColor: "green",
            borderRadius: "15px",
            color: "white",
          }}
          onClick={() => {
            handleButValider();
          }}
        >
          Choisir
        </Button>
      </div>
    </div>
  );
};

export default ServiceCardItem;
